// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2Wby-","search":"Settings_search__2_rfZ","filter":"Settings_filter__Yxeuc"};